import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import axios from "axios";
import { setOpenChoiceComponentAR, setOpenMainMenu, setOpenModalAddUser, setOpenUserManagment } from "../Reducer/ModalSlice";
import { IoClose } from "react-icons/io5"
import { CityFromAddUserAdd, EditUserAddCity, EditUserAddResponsibleUser } from "../Reducer/CitySlice";
import { addUsers } from "../Reducer/UserSlice";
import { addEditUser } from "../Reducer/AddUserSlice";
import { roleId } from "../Components/Constants/app";

function UserManagment() {
    const User = useSelector(state => state.UserSlice.User)
    const ArrayUsers = useSelector(state => state.UserSlice.ArrayUsers)
    const Server = useSelector(state => state.UserSlice.Server)

    const OpenModal = useSelector(state => state.ModalSlice.OpenModal)

    const CityArray = useSelector(state => state.CitySlice.CityArray)

    const dispatch = useDispatch()

    const [ModalDeletedUser, setModalDeletedUser] = useState(false)
    const [UserSaver, setUserSaver] = useState()
    const [CancelTouch, setCancelTouch] = useState(false)

    const handleClickButtonDeleteUser = async (event) => {
        if(event.type === 'touchend')
            event.preventDefault()

        await axios.delete(Server + "users/" + UserSaver.id, {
            headers: {
                Authorization: 'Bearer ' + User.jwt,
            },
        })
        dispatch(CityFromAddUserAdd())
        await axios.get(Server + "users?_limit=-1", {
            headers: {
                Authorization: 'Bearer ' + User.jwt,
            }
        })
        .then((response) => {
            var addedUsersArray = response.data.filter(el => el.role.id !== roleId.admin)
            dispatch(addUsers(addedUsersArray))
        });
        setUserSaver()
        setModalDeletedUser(false)
    }

    return(
        <div
        className="ModalGlobalDiv"
        >
            <div
            className="ModalStaffManagmentMainDiv"
            >
                <div
                className="ModalInformationDiv"
                >
                    <div
                    className="ModalInformationTextDiv"
                    >
                        Пользователи
                    </div>
                    <button
                    className="CloseModalIconDiv"
                    onClick={(() => {
                        if(OpenModal.SelectedSystem === 'FOT')
                            dispatch(setOpenMainMenu(true))

                        if(OpenModal.SelectedSystem === 'AR')
                            dispatch(setOpenChoiceComponentAR(true))

                        dispatch(setOpenUserManagment(false))
                    })}
                    onTouchStart={() => {
                        setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={((event) => {
                        event.preventDefault()
                        if(!CancelTouch)
                        {
                            if(OpenModal.SelectedSystem === 'FOT')
                                dispatch(setOpenMainMenu(true))
    
                            if(OpenModal.SelectedSystem === 'AR')
                                dispatch(setOpenChoiceComponentAR(true))

                            dispatch(setOpenUserManagment(false))
                        }
                    })}
                    >
                        <IoClose
                        className="CloseModalIcon"
                        />
                    </button>
                </div>
                <div
                className="ModalStaffManagmentDiv"
                >
                    {ArrayUsers.map((el) => 
                        <div
                        key={el.id}
                        className="OneStaffManagmentDiv"
                        >
                            <div>
                            {el.FIO}
                            </div>
                            <div
                            className="DivFlex Gap"
                            >
                                <button
                                className="ModalDeletedStaffButton Delete"
                                onClick={(() => {
                                    setModalDeletedUser(true)
                                    setUserSaver(el)
                                })}
                                onTouchStart={() => {
                                    setCancelTouch(false)
                                }}
                                onTouchMove={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchCancel={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchEnd={((event) => {
                                    event.preventDefault()
                                    if(!CancelTouch)
                                    {
                                        setModalDeletedUser(true)
                                        setUserSaver(el)
                                    }
                                })}
                                >
                                    Удалить
                                </button>               

                                <button
                                className="ModalDeletedStaffButton UnDelete"
                                onClick={(async () => {
                                    await dispatch(addEditUser({idUser: el.id, FIO: el.FIO, Email: el.email, Role: el.role.id}))
                                    var CityChek = el.idCity.split('_')
                                    await CityChek.map((item) => {
                                        dispatch(EditUserAddCity(parseInt(item)))
                                        return(item)
                                    })    

                                    await CityArray.map((item) => {
                                        if(item.NameAccountantUser === el.FIO || item.NameResponsibleUser === el.FIO)
                                            dispatch(EditUserAddResponsibleUser(item.id))
                                        return(item)
                                    })        

                                    await dispatch(setOpenModalAddUser(true))
                                    dispatch(dispatch(setOpenUserManagment(false)))
                                })}
                                onTouchStart={() => {
                                    setCancelTouch(false)
                                }}
                                onTouchMove={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchCancel={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchEnd={(async (event) => {
                                    event.preventDefault()
                                    if(!CancelTouch)
                                    {
                                        await dispatch(addEditUser({idUser: el.id, FIO: el.FIO, Email: el.email, Role: el.role.id}))
                                        var CityChek = el.idCity.split('_')
                                        await CityChek.map((item) => {
                                            dispatch(EditUserAddCity(parseInt(item)))
                                            return(item)
                                        })   
                                        
                                        await CityArray.map((item) => {
                                            if(item.NameAccountantUser === el.FIO || item.NameResponsibleUser === el.FIO)
                                                dispatch(EditUserAddResponsibleUser(item.id))
                                            return(item)
                                        })    

                                        await dispatch(setOpenModalAddUser(true))
                                        dispatch(setOpenUserManagment(false))
                                    }
                                })}
                                >
                                    Изменить
                                </button>            
                            </div>
                        </div>
                    )}
                </div>

                    {ModalDeletedUser &&
                    <div
                    className="ModalChangeHiddenGlobalDiv"
                    >

                        <div
                        className="ModalChangeHiddenMainDiv"
                        >
                            <div>
                            {'Пользователь ' + UserSaver.FIO + ' и данные о нем будут полностью удалены без возможности восстановления' }
                            </div>
                            <div
                            className="ModalChangeHiddenButtonsDiv"
                            >
                                <button
                                className="ModalChangeHiddenButton Cancle"
                                onClick={(() => {
                                    setUserSaver()
                                    setModalDeletedUser(false)
                                })}
                                onTouchStart={() => {
                                    setCancelTouch(false)
                                }}
                                onTouchMove={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchCancel={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchEnd={((event) => {
                                    event.preventDefault()
                                    if(!CancelTouch)
                                    {
                                        setUserSaver()
                                        setModalDeletedUser(false)
                                    }
                                })}
                                >
                                    Отмена
                                </button>
                                <button
                                className="ModalChangeHiddenButton Ok"
                                onClick={handleClickButtonDeleteUser}
                                onTouchStart={() => {
                                    setCancelTouch(false)
                                }}
                                onTouchMove={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchCancel={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchEnd={(event) => {
                                    event.preventDefault()
                                    if(!CancelTouch)
                                        handleClickButtonDeleteUser(event)
                                }}
                                >
                                    Ок
                                </button>
                            </div>
                        </div>
                    </div>
                    }
            </div>
        </div>
    )
}

export default UserManagment;
